export const useRegistrationFormSubmit = async (path: string, body: string) => {
  const result = await fetch(`/api${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: body,
  })

  if (result.status === 200) {
    return await result.json()
  }

  throw new Error(`Registration failed with status ${result.status}`)
}
